import { render, staticRenderFns } from "./project-article.vue?vue&type=template&id=6ebede72&scoped=true&"
import script from "./project-article.vue?vue&type=script&lang=js&"
export * from "./project-article.vue?vue&type=script&lang=js&"
import style0 from "./project-article.vue?vue&type=style&index=0&id=6ebede72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebede72",
  null
  
)

export default component.exports